import curdEditFooterButtonGroup from './curdEditFooterButtonGroup.vue'
export default curdEditFooterButtonGroup
